module.exports = __webpack_public_path__ + "img/systemComponentsHierarchies.60c40626.svg";